<template>
  <div class="modal-mask">
    <div class="modal-wrapper">
      <div class="modal-container stitcher-modal flex flex-items--start">
        <button class="ghost-button mar-top--xl mar-right--xl" @click="$emit('close')">
          <span class="x-icon x-icon--circle"></span>
        </button>
        <div class="flex-grow--1">
          <div class="modal-header">
              <h1>Stitcher Schedule</h1>
              <hr>
          </div>
          <div class="modal-body">
              <b-alert show v-if="errorSaveMessage" class="error" >{{errorSaveMessage}}</b-alert>
            <b-alert show dismissible v-if="errorResponse" class="success" >{{message}}</b-alert>
            <span class=" flex flex-item-center">
              <span class="heading mar-right--md">Stoke Stitcher Runs Daily</span>
              <span class="heading mar-left--xl mar-right--md">Time:</span>
              <FormSelect
                v-model='schedule.hour'
                :options="hours"
                selectValue="name"
                select-class="select--grey"
                ></FormSelect>
              <span class="mar-x--sm">:</span>
              <FormSelect
                v-model='schedule.minute'
                :options="minutes"
                selectValue="name"
                select-class="select--grey"
                ></FormSelect>
                <FormSelect
                  class="mar-left--sm"
                  v-model='schedule.period'
                  :options="period"
                  selectValue='name'
                  select-class="select--grey"
                  ></FormSelect>
            </span>

            <div class="bkg--concrete pad-x--md pad-y--xl mar-top--xl">
              <div>
                  <b-alert show v-if="error" class="error" >{{errorMessage}}</b-alert>
              </div>

              <span class=" flex flex-items--center mar-bottom--lg pad-bottom--lg border-white--bottom">
                <span class="heading mar-right--sm" style="width: 211px;">If error occurs, send report to: </span>
                <input class="inline-textfield flex-grow--1" type="email" v-model='schedule.email_error' @change='updateError'>
              </span>
              <b-alert show v-if="errorSucces" class="error" >{{errorMessageSuccess}}</b-alert>
              <span class=" flex flex-items--center">
                <span class="heading mar-right--sm" style="width: 211px;">If import succeeds, send report to: </span>
                <input class="inline-textfield flex-grow--1" type="email" v-model='schedule.email_success' @change='updateSuccess'>
              </span>

            </div>
          </div>

          <div class="modal-footer">
              <button class="ghost-button" @click="$emit('cancel')">Cancel</button>
              <button class="purple-button purple-button--squished" @click="save">Save</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import FormSelect from '@/components/FormSelect'
export default {
  components: {
    FormSelect
  },
  props: {
    schedule: {
      type: Object
    },
    errorSaveMessage: {
      type: String
    }
  },
  data () {
    return {
      error: false,
      errorMessage: '',
      errorSucces: false,
      errorMessageSuccess: '',
      message: '',
      errorResponse: false,
      hours: [],
      minutes: [],
      period: [{ 'name': 'AM' }, { 'name': 'PM' }],
      select_period: ''
    }
  },
  computed: {},
  methods: {
    save () {
      this.updateError()
      this.updateSuccess()
      if (!this.error && !this.errorSucces) {
        this.$emit('save', this.schedule)
      }
    },
    makeHourArray () {
      var i = 1
      for (i; i < 13; i++) {
        this.hours.push({ 'name': i })
      }
    },
    makeMinutesArray () {
      var i = 0
      for (i; i < 61;) {
        const minute = i < 10 ? `0${i}` : i
        this.minutes.push({ 'name': minute })
        i = i + 5
      }
    },
    updateError () {
      this.errorMessage = ''
      var isValidEmail = this.emailValid(this.schedule.email_error)
      if (!isValidEmail) {
        this.error = true
        this.errorMessage = 'You have an invalid email address.'
      } else {
        this.error = false
      }
    },
    updateSuccess () {
      this.errorMessageSuccess = ''
      var isValidEmail = this.emailValid(this.schedule.email_success)
      if (!isValidEmail) {
        this.errorSucces = true
        this.errorMessageSuccess = 'You have an invalid email address.'
      } else {
        this.errorSucces = false
      }
    },
    emailValid (emailList) {
      if (emailList) {
        var emailArray = emailList.split(',')
        var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        var i = 0
        for (i; i < emailArray.length; i++) {
          emailArray[i] = emailArray[i].trim()
          var isValidEmail = re.test(String(emailArray[i]))
          if (!isValidEmail) {
            return false
          }
        }
        return true
      } else {
        return true
      }
    }
  },
  mounted () {
    if (this.schedule.minute === 5) {
      this.schedule.minute = `0${this.schedule.minute}`
    }
    this.makeHourArray()
    this.makeMinutesArray()
  }
}
</script>
<style scoped>
  .modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  display: table;
  transition: opacity .3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  width: 75%;
  margin: 0px auto;
  padding: 20px 30px;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
  transition: all .3s ease;
  font-family: Helvetica, Arial, sans-serif;
}

.modal-header h3 {
  margin-top: 0;
  color: #42b983;
}

.modal-body {
  margin: 20px 0;
}

/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
</style>
